import { render, staticRenderFns } from "./soleHeader.vue?vue&type=template&id=71480a74&scoped=true&"
import script from "./soleHeader.vue?vue&type=script&lang=js&"
export * from "./soleHeader.vue?vue&type=script&lang=js&"
import style0 from "./soleHeader.vue?vue&type=style&index=0&id=71480a74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71480a74",
  null
  
)

export default component.exports